// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"240":"support","484":"documentsUpload","687":"create","932":"owner","962":"home"}[chunkId] + ".css";
};